import { useQuery } from "@tanstack/react-query";
import { appointmentsAPI } from "@/lib/appointments-api";
import { queryKeys } from "@/lib/query-keys";
import { useAuthStore } from "@/stores/authStore";
import type { AdminAppointmentListParams } from "@/types/appointments";

export const useAdminAppointmentList = (
  params: AdminAppointmentListParams,
  enabled = true
) => {
  const userId = useAuthStore((state) => state.user?.id);

  return useQuery({
    queryKey: queryKeys.appointments.adminList({ userId, ...params }),
    queryFn: () => appointmentsAPI.getAdminAppointmentList(params),
    retry: false,
    enabled: enabled && !!userId,
  });
};

export const useStaffUpcomingAppointments = (page?: number) => {
  const userId = useAuthStore((state) => state.user?.id);
  return useQuery({
    queryKey: queryKeys.appointments.staff.upcoming(userId, page),
    queryFn: () => appointmentsAPI.getStaffUpcomingAppointments(page),
    retry: false,
    enabled: !!userId,
  });
};

export const useStaffOngoingAppointments = (page?: number) => {
  const userId = useAuthStore((state) => state.user?.id);
  return useQuery({
    queryKey: queryKeys.appointments.staff.ongoing(userId, page),
    queryFn: () => appointmentsAPI.getStaffOngoingAppointments(page),
    retry: false,
    enabled: !!userId,
  });
};

export const useStaffHistoryAppointments = (page?: number) => {
  const userId = useAuthStore((state) => state.user?.id);
  return useQuery({
    queryKey: queryKeys.appointments.staff.history(userId, page),
    queryFn: () => appointmentsAPI.getStaffHistoryAppointments(page),
    retry: false,
    enabled: !!userId,
  });
};
